import { useCallback, useEffect } from 'react';
import { useCanViewCollectionView } from '@shared/data/billing/hooks/useCanViewCollectionView';
import { MBAnalytics } from '@shared/util/analytics';
import { PAYWALL_EXPERIMENT, useFeatureFlag } from '../';

export function useTrackPaywallExperimentClick(group) {
  return useCallback(() => {
    MBAnalytics.track('PaywallExperiment::Click', {
      group,
    });
  }, [group]);
}

export function useTrackPaywallExperimentView(group) {
  const isPaid = useCanViewCollectionView();

  useEffect(() => {
    if (isPaid) {
      return;
    }
    MBAnalytics.track('PaywallExperiment::View', {
      group,
    });
  }, [group, isPaid]);
}

export function usePaywallExperiment() {
  const groupName = useFeatureFlag(PAYWALL_EXPERIMENT);

  return {
    isRedactedGroup: groupName === 'redacted',
    isBannerGroup: groupName === 'banner',
    groupName,
  };
}
